// @flow

import React, { Component } from 'react';
import { Table } from 'semantic-grab-ui/src';

type Props = {
  firstCell: any,
  secondCell: any,
}

export default class TwoCellRow extends Component {
  props: Props;

  render() {
    const { firstCell, secondCell } = this.props;
    return (
      <Table.Row>
        <Table.Cell>
          <span>{ firstCell }</span>
        </Table.Cell>
        <Table.Cell>
          <span>{ secondCell }</span>
        </Table.Cell>
      </Table.Row>
    );
  }
}
